import React from 'react';
import { withTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import { updateQuestion } from '../actions/';
import configData from "../../../Config/QuestionLevel.json";
import api from '../../../../api/api';

class Info extends React.Component {

    state = {
        QuestionId: 0,
        title: '',
        Position: false,
        IsRelativeToTopic: null,
        first: true,
        Level: '',
        errorList: [],
        topicsCategories: [],
        showDropdown: false,
        searchTerm: '',
        expandedCategories: []
    };

    constructor(props) {
        super(props);
        this._editor = new React.createRef();
        this.treeSelectRef = React.createRef();
        this.QuestionLevel = configData.QuestionLevel;
    }

    static getDerivedStateFromProps(props, state) {
        state.QuestionId = props.QuestionId;
        state.title = props.title;
        state.Level = props.Level;
        state.Mark = props.mark;
        state.Position = props.Position;
        state.IsRelativeToTopic = props.IsRelativeToTopic;

        if (state.title && state.first) {
            state.first = false;
            setTimeout(() => {
                window.createRedactor("#QuestionTitle", state.title);
            }, 400);
        }
        return state;
    }

    componentDidMount() {
        setTimeout(() => {
            if (this.state.QuestionId === 0) {
                window.createRedactor("#QuestionTitle", "");
            }
        }, 700);

        document.addEventListener("mousedown", this.handleClickOutside);

        api.get('/QuestionsLookups/TopicsCategories')
            .then(res => {
                let data = [];
                if (Array.isArray(res.data?.data)) {
                    data = res.data.data;
                } else if (Array.isArray(res.data?.data?.data)) {
                    data = res.data.data.data;
                }
                this.setState({
                    topicsCategories: data
                });
            })
            .catch(err => {
                console.error("Error fetching topics:", err);
            });
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.treeSelectRef.current && !this.treeSelectRef.current.contains(event.target)) {
            this.setState({ showDropdown: false });
        }
    }

    toggleDropdown = () => {
        this.setState({ showDropdown: !this.state.showDropdown });
    }

    handleSearchChange = e => {
        this.setState({ searchTerm: e.target.value });
    }

    toggleCategory = (categoryId) => {
        const expanded = [...this.state.expandedCategories];
        if (expanded.includes(categoryId)) {
            this.setState({ expandedCategories: expanded.filter(id => id !== categoryId) });
        } else {
            expanded.push(categoryId);
            this.setState({ expandedCategories: expanded });
        }
    }

    isCategoryExpanded = (categoryId) => {
        if (this.state.searchTerm) return true;
        return this.state.expandedCategories.includes(categoryId);
    }

    handleTopicToggle = (topicId) => {
        let currentTopicIds = [...(this.props.TopicIds || [])];
        if (currentTopicIds.includes(topicId)) {
            currentTopicIds = currentTopicIds.filter(id => id !== topicId);
        } else {
            currentTopicIds.push(topicId);
        }
        this.props.setTopicIds(currentTopicIds);

        var copy = this.props.question;
        if (copy && copy.question) {
            copy.question = {
                ...copy.question,
                Topics: currentTopicIds
            }
            this.props.updateQuestion(copy);
        }
    }

    renderField = ({
        input,
        title,
        type,
        defaultValue,
        id,
        placeholder,
        meta: { touched, error }
    }) => (
        <div className="modern-input-wrapper">
            <input {...input} id={id} value={defaultValue} title={title} placeholder={placeholder} type={type} autoComplete="off" className={`form-control ${(touched && error) ? 'is-invalid' : ''}`} />
            {touched && error && <div className="invalid-feedback">{error}</div>}
        </div>
    );

    validateQuestionMark = value => {
        const { t } = this.props;
        if (!value || value <= 0) {
            return t('Pages.Lessons.Questions.forms.QuestionMark.placeholder');
        }
    }

    setMarkValue = value => {
        this.setState({
            Mark: value
        });
        this.props.setMark(value);
        var copy = this.props.question;
        copy.question = {
            ...copy.question,
            Mark: value
        }
        this.props.updateQuestion(copy);
    }

    setLevel = value => {
        var index = value.nativeEvent.target.selectedIndex;
        let Level = parseInt(value.nativeEvent.target.value);
        this.setState({
            Level: Level
        });
        this.props.setLevel(Level);
        var copy = this.props.question;
        copy.question = {
            ...copy.question,
            Level: {
                Id: Level,
                Name: value.nativeEvent.target[index].text
            }
        }
        this.props.updateQuestion(copy);
    }

    setPosition = value => {
        this.setState({
            Position: value
        });
        this.props.setPosition(value);
        var copy = this.props.question;
        copy.question = {
            ...copy.question,
            Position: value
        }
        this.props.updateQuestion(copy);
    }

    setIsRelativeToTopic = value => {
        this.setState({
            IsRelativeToTopic: value
        });
        this.props.setIsRelativeToTopic(value);
        var copy = this.props.question;
        if (copy && copy.question) {
            copy.question = {
                ...copy.question,
                IsRelativeToTopic: value
            }
            this.props.updateQuestion(copy);
        }
    }

    renderQuestionLevel() {
        return this.QuestionLevel.map(level => {
            return <option key={level.value} value={level.value}  > {level.label}</option >;
        });
    }

    submitMainInfo = () => {
        const { t } = this.props;
        var QuestionTitle = window.getRedactor("#QuestionTitle");

        var errors = this.validate(this.state.Mark, QuestionTitle);
        if (errors.length !== 0) {
            var errorList = errors.map((error, index) => {
                return <li key={`error-${index}`}>{error.placeholder}.</li>;
            });
            this.setState({ errorList: errorList });

            this.props.toast.error(t('Error.AllInformationIsRequired.Body'), {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } else {
            this.setState({ errorList: [] });
            this.props.submitMainInfo(QuestionTitle, this.state.Mark, this.Level ? this.Level.value : 1, this.props.Position, this.state.IsRelativeToTopic, this.props.TopicIds);
        }
    }

    validate(Mark = '', QuestionTitle = '') {
        const { t, typeId } = this.props;
        const errors = [];

        if (typeId !== 11 && (Mark.length === 0 || Mark <= 0)) {
            errors.push({ placeholder: t('Pages.Lessons.Questions.forms.QuestionMark.placeholder'), name: 'Mark' });
        }
        if (QuestionTitle.length === 0) {
            errors.push({ placeholder: t('Pages.Lessons.Questions.forms.QuestionTitle.placeholder'), name: 'QuestionTitle' });
        }
        return errors;
    }

    render() {
        const { t } = this.props;

        const rawCategories = Array.isArray(this.state.topicsCategories)
            ? this.state.topicsCategories
            : (Array.isArray(this.state.topicsCategories?.data) ? this.state.topicsCategories.data : []);

        const selectedCategoriesList = [];
        let totalSelectedCount = 0;
        rawCategories.forEach(cat => {
            if (cat && cat.Topics && Array.isArray(cat.Topics)) {
                const matchedSelected = cat.Topics.filter(topic =>
                    (this.props.TopicIds || []).includes(topic.TopicId)
                );
                if (matchedSelected.length > 0) {
                    totalSelectedCount += matchedSelected.length;
                    selectedCategoriesList.push({
                        CategoryId: cat.CategoryId,
                        CategoryName: cat.CategoryName,
                        Topics: matchedSelected
                    });
                }
            }
        });

        const filteredCategories = rawCategories.map(cat => {
            const matchedTopics = (cat.Topics || []).filter(t =>
                t.TopicName.toLowerCase().includes(this.state.searchTerm.toLowerCase())
            );
            return { ...cat, Topics: matchedTopics };
        }).filter(cat => cat.Topics.length > 0);

        return (
            <div className="modern-info-container">
                <div className={`modern-error-alert ${this.state.errorList.length === 0 ? 'd-none' : ''}`} role="alert">
                    <div className="modern-error-title">
                        <i className="fal fa-exclamation-circle ml-2"></i>
                        {t('Error.AllInformationIsRequired.Title') || 'الرجاء ملء كافة الحقول المطلوبة'}
                    </div>
                    <ul className="modern-error-list">
                        {this.state.errorList}
                    </ul>
                </div>

                <div className="modern-form-section">
                    <div className="modern-section-title">
                        <i className="icon fal fa-text"></i>
                        {
                            this.props.isForGame ?
                                t('Pages.Games.forms.LessonInfo.QuestionInfo')
                                :
                                t('Pages.Lessons.Questions.forms.Info')
                        }
                    </div>
                    <div className="form-group w-100 mb-0">
                        <label className="modern-label" htmlFor="QuestionTitle">
                            {
                                this.props.isForGame ?
                                    t('Pages.Games.forms.LessonInfo.QuestionInfo')
                                    :
                                    t('Pages.Lessons.Questions.forms.QuestionTitle.title')
                            }
                        </label>
                        <textarea id="QuestionTitle" autoComplete="off" placeholder={t('Pages.Lessons.Questions.forms.QuestionTitle.placeholder')} className="form-control" ref={this._editor} ></textarea>
                    </div>

                    {
                        this.props.isForGame && (
                            <div className="w-100 mt-4">
                                <label className="modern-label">
                                    <i className="icon fal fa-gamepad"></i> {t('Pages.Games.forms.LessonInfo.Type') || 'نوع سؤال اللعبة:'}
                                </label>
                                <div className="toggle-cards-group">
                                    <div
                                        className={`toggle-card ${this.state.Position ? 'active-primary' : ''}`}
                                        onClick={() => this.setPosition(true)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Games.forms.LessonInfo.IsForFun')}</span>
                                        </div>
                                        <i className="icon fa-regular fa-gamepad-modern toggle-card-icon"></i>
                                    </div>
                                    <div
                                        className={`toggle-card ${!this.state.Position ? 'active-primary' : ''}`}
                                        onClick={() => this.setPosition(false)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Games.forms.LessonInfo.IsQuestion')}</span>
                                        </div>
                                        <i className="icon fa-regular fa-block-question toggle-card-icon"></i>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>

                {
                    this.props.typeId !== 11 && (
                        <div className="modern-form-section">
                            <div className="modern-section-title">
                                <i className="icon fal fa-sliders-h"></i>
                                {t('Pages.Lessons.Questions.forms.tools.Settings') || 'إعدادات العلامات والصعوبة'}
                            </div>
                            <div className="modern-grid">
                                <div className="form-group mb-0 w-100">
                                    <label className="modern-label" htmlFor="Mark">
                                        <i className="icon fas fa-tally"></i>
                                        {
                                            this.state.Position ?
                                                t('Pages.Games.forms.LessonInfo.TryCount')
                                                :
                                                t('Pages.Lessons.Questions.forms.QuestionMark.title')
                                        }
                                    </label>
                                    <Field
                                        ref={Mark => this.Mark = Mark}
                                        id="Mark"
                                        name="Mark"
                                        component={this.renderField}
                                        defaultValue={this.state.Mark}
                                        type="number"
                                        required={true}
                                        onChange={e => this.setMarkValue(e.target.value)}
                                        validate={this.validateQuestionMark}
                                        placeholder={this.state.Position ? t('Pages.Games.forms.LessonInfo.TryCountInfo') : t('Pages.Lessons.Questions.forms.QuestionMark.placeholder')}
                                        title={this.state.Position ? t('Pages.Games.forms.LessonInfo.TryCount') : t('Pages.Lessons.Questions.forms.QuestionMark.title')}
                                    />
                                </div>
                                <div className="form-group mb-0 w-100">
                                    <label className="modern-label" htmlFor="Level">
                                        <i className="icon fas fa-water-rise"></i>
                                        {t('Pages.Lessons.Questions.forms.QuestionLevel.title')}
                                    </label>
                                    <div className="modern-input-wrapper">
                                        <select
                                            id="Level"
                                            className="form-control"
                                            required={true}
                                            ref={Level => this.Level = Level}
                                            value={this.state.Level}
                                            onChange={e => this.setLevel(e)}
                                            placeholder={t('Pages.Lessons.Questions.forms.QuestionLevel.placeholder')}
                                            title={t('Pages.Lessons.Questions.forms.QuestionLevel.title')}>
                                            {this.renderQuestionLevel()}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }

                {
                    this.props.isForGame || this.props.type === "SelfDevelopment" ? "" :
                        <div className="modern-form-section">
                            <div className="modern-section-title">
                                <i className="icon fal fa-laptop-code"></i>
                                {t('Pages.Lessons.Questions.forms.tools.LayoutAndRelativity') || 'تنسيق العرض والارتباط'}
                            </div>

                            <div className="w-100 mb-4">
                                <label className="modern-label">
                                    <i className="icon fal fa-arrows-h"></i> {t('Pages.Lessons.Questions.forms.tools.position') || 'موضع السؤال في الصفحة:'}
                                </label>
                                <div className="toggle-cards-group">
                                    <div
                                        className={`toggle-card ${this.state.Position ? 'active-success' : ''}`}
                                        onClick={() => this.setPosition(true)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Lessons.Questions.forms.tools.positionRight')}</span>
                                            <span className="toggle-card-desc">{t('Pages.Lessons.Questions.forms.tools.positionRightDesc') || 'عرض السؤال على الجانب الأيمن'}</span>
                                        </div>
                                        <i className="icon fad fa-arrow-alt-from-left toggle-card-icon"></i>
                                    </div>
                                    <div
                                        className={`toggle-card ${!this.state.Position ? 'active-success' : ''}`}
                                        onClick={() => this.setPosition(false)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t('Pages.Lessons.Questions.forms.tools.positionLeft')}</span>
                                            <span className="toggle-card-desc">{t('Pages.Lessons.Questions.forms.tools.positionLeftDesc') || 'عرض السؤال على الجانب الأيسر'}</span>
                                        </div>
                                        <i className="icon fad fa-arrow-alt-from-right toggle-card-icon"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="w-100">
                                <label className="modern-label">
                                    <i className="icon fal fa-sitemap"></i> {t("QuestionView.isRelativeToTopic") || "ارتباط السؤال بالنص (تحديد نوع الارتباط):"}
                                </label>
                                <div className="toggle-cards-group">
                                    <div
                                        className={`toggle-card ${this.state.IsRelativeToTopic === true ? 'active-info' : ''}`}
                                        onClick={() => this.setIsRelativeToTopic(true)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t("QuestionView.general") || "عام (مستقل)"}</span>
                                            <span className="toggle-card-desc">{t("QuestionView.generalOption") || "لا يتطلب قراءة نص الدرس للإجابة عليه"}</span>
                                        </div>
                                        <i className="icon fal fa-shield-check toggle-card-icon"></i>
                                    </div>
                                    <div
                                        className={`toggle-card ${this.state.IsRelativeToTopic === false ? 'active-info' : ''}`}
                                        onClick={() => this.setIsRelativeToTopic(false)}
                                    >
                                        <div className="toggle-card-radio">
                                            <div className="toggle-card-radio-inner"></div>
                                        </div>
                                        <div className="toggle-card-content">
                                            <span className="toggle-card-title">{t("QuestionView.relativeToText") || "مرتبط بالنص"}</span>
                                            <span className="toggle-card-desc">{t("QuestionView.relativeToTextOption") || "يتطلب قراءة نص الدرس للإجابة عليه"}</span>
                                        </div>
                                        <i className="icon fal fa-book-reader toggle-card-icon"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                }

                <div className="modern-form-section">
                    <div className="modern-section-title">
                        <i className="icon fal fa-sitemap"></i>
                        {t("QuestionView.topicsSection") || "المواضيع التعليمية المرتبطة"}
                    </div>
                    <div className="form-group w-100 mb-0">
                        <label className="modern-label">
                            {t("QuestionView.topics") || "مواضيع السؤال:"}
                        </label>
                        <div className="modern-tree-select-wrapper" ref={this.treeSelectRef}>
                            <div className="modern-tree-select-trigger" onClick={this.toggleDropdown}>
                                <div className="modern-tree-select-values">
                                    {totalSelectedCount > 0
                                        ? `${t('QuestionView.selectedTopicsList') || 'المواضيع المختارة'} (${totalSelectedCount})`
                                        : (t('QuestionView.selectTopics') || 'اختر المواضيع...')}
                                </div>
                                <i className={`fad fa-chevron-down arrow-icon ${this.state.showDropdown ? 'open' : ''}`}></i>
                            </div>
                            {this.state.showDropdown && (
                                <div className="modern-tree-select-dropdown">
                                    <div className="modern-tree-search-wrapper">
                                        <input
                                            type="text"
                                            className="form-control modern-search-input"
                                            placeholder={t('QuestionView.searchTopics')}
                                            value={this.state.searchTerm}
                                            onChange={this.handleSearchChange}
                                            onClick={e => e.stopPropagation()}
                                        />
                                        <i className="fal fa-search search-icon"></i>
                                    </div>
                                    <div className="modern-tree-nodes">
                                        {filteredCategories.map(cat => (
                                            <div key={cat.CategoryId} className="modern-tree-category">
                                                <div className="modern-category-header" onClick={() => this.toggleCategory(cat.CategoryId)}>
                                                    <i className={`far ${this.isCategoryExpanded(cat.CategoryId) ? 'fa-folder-open' : 'fa-folder'} category-folder-icon`}></i>
                                                    <span className="category-name">{cat.CategoryName}</span>
                                                    <span className="category-badge">{cat.Topics.length}</span>
                                                    <i className={`fal fa-chevron-down category-chevron ${this.isCategoryExpanded(cat.CategoryId) ? 'expanded' : ''}`}></i>
                                                </div>
                                                {this.isCategoryExpanded(cat.CategoryId) && (
                                                    <div className="modern-category-children">
                                                        {cat.Topics.map(topic => (
                                                            <label key={topic.TopicId} className="modern-tree-item" onClick={e => e.stopPropagation()}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={(this.props.TopicIds || []).includes(topic.TopicId)}
                                                                    onChange={() => this.handleTopicToggle(topic.TopicId)}
                                                                />
                                                                <span className="checkbox-custom"></span>
                                                                <span className="topic-name">{topic.TopicName}</span>
                                                                {topic.QuestionCount > 0 && (
                                                                    <span className="topic-question-count">({topic.QuestionCount} {t('QuestionView.questionsCount')})</span>
                                                                )}
                                                            </label>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>

                        {selectedCategoriesList.length > 0 && (
                            <div className="selected-topics-tags-list mt-3">
                                <div className="selected-topics-label">
                                    <i className="far fa-tags ml-1"></i>
                                    {t("QuestionView.selectedTopicsList") || "المواضيع المختارة:"}
                                </div>
                                <div className="selected-categories-container">
                                    {selectedCategoriesList.map(cat => (
                                        <div key={cat.CategoryId} className="selected-category-group mb-2">
                                            <div className="selected-category-header-title">
                                                <i className="far fa-folder-open ml-1 text-primary"></i>
                                                <span className="category-group-name">{cat.CategoryName}</span>
                                                <span className="selected-category-badge">({cat.Topics.length})</span>
                                            </div>
                                            <div className="selected-tags-container">
                                                {cat.Topics.map(topic => (
                                                    <div key={topic.TopicId} className="selected-topic-chip">
                                                        <i className="far fa-bookmark topic-chip-icon"></i>
                                                        <span className="topic-chip-name">{topic.TopicName}</span>
                                                        <button
                                                            type="button"
                                                            className="topic-chip-remove"
                                                            title={t('Cancel') || 'حذف'}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                this.handleTopicToggle(topic.TopicId);
                                                            }}
                                                        >
                                                            <i className="far fa-times"></i>
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="form-group w-100 text-center mt-4">
                    <button className="premium-btn-save" title={t('Pages.Lessons.Questions.forms.tools.saveAndContinue')} type="button" onClick={() => this.submitMainInfo()}>
                        <i className="icon far fa-save"></i>
                        <span>
                            {
                                this.props.isForGame ?
                                    t('Pages.Games.forms.LessonInfo.saveAndContinue')
                                    :
                                    t('Pages.Lessons.Questions.forms.tools.saveAndContinue')
                            }
                        </span>
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        question: state.questions
    };
};

export default connect(mapStateToProps, { updateQuestion })(withTranslation('common')(Info));
